(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uiara-bh"]) return;
  try {
    
if (!customElements.get('uiara-landing-controller')) {
  customElements.define('uiara-landing-controller', class extends HTMLElement {
    connectedCallback() {
      const root = this.parentElement;
      this.abort = new AbortController();
      root.querySelectorAll('[data-gallery]').forEach(g => g.querySelectorAll('[data-direction],.uiara-dots').forEach(el => el.hidden = false));
      const show = (g, index) => {
        const imgs = [...g.querySelectorAll('.uiara-slide')];
        if (!imgs.length) return;
        index = (index + imgs.length) % imgs.length;
        imgs.forEach((el, i) => { el.hidden = i !== index; el.classList.toggle('active', i === index); });
        g.querySelectorAll('[data-slide]').forEach((el, i) => { el.classList.toggle('active', i === index); el.setAttribute('aria-pressed', String(i === index)); });
      };
      root.addEventListener('click', e => {
        const button = e.target.closest('[data-direction],[data-slide]');
        if (!button) return;
        const g = button.closest('[data-gallery]');
        const current = [...g.querySelectorAll('.uiara-slide')].findIndex(el => !el.hidden);
        show(g, button.hasAttribute('data-slide') ? Number(button.dataset.slide) : current + Number(button.dataset.direction));
      }, {signal:this.abort.signal});
      root.addEventListener('change', e => {
        const input = e.target;
        if (!input.matches('input[type=radio][name=id]')) return;
        const card = input.closest('[data-card]');
        card.querySelector('[data-price]').textContent = input.dataset.price;
        card.querySelector('[data-installments]').textContent = input.dataset.installments;
        const compare = card.querySelector('[data-compare]');
        compare.textContent = input.dataset.compare;
        compare.hidden = !input.dataset.compare;
        const g = card.querySelector('[data-gallery]');
        const index = [...g.querySelectorAll('.uiara-slide')].findIndex(img => img.dataset.imageId === input.dataset.image);
        if (index >= 0) show(g, index);
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
